export enum Discipline {
  DERSSAGE = '6630e7876dc89f8784fe328a',
  WESTERN = '6630e7806dc89f8784fe3287',
  HUNT_SEAT = '6630e7786dc89f8784fe3284',
}
